
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAByUExURQAAAP////////////////////////////////// //////Dy98XO35mpyIudwL7I3OLn75KjxL3H3OLm79vg66GvzK+71LfC2Pj5+9Ta58XO4NPa56i2 0MXN35qpyL7I26i10M3U4/Hz9+rt88zU4wAAALNGd6YAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAA AWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAAC/SURB VCjPnZLhEoIgDIAngtrUZZKJZVbW+z9jkOKVx66r7wc/9rGNYwOwRCLGD6RKYCLNMIBIX05iEOls hgwCIEGWCBQvBfiOebGQz6EY/LWSFkofWyS98avcVo5dWNbasi//KtvwstYHorZC0zFlj6iLkwnL Hs/UD6UJyi63DTu6BGWliQw2fTjT2J9tqF3Lwckr3uw5jF761Rrnad2Lh3+PBMEPW0HES7uebKr4 tpqQBnOnpbYkapUdi42LPwGuCSEWFU629AAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQw MjozMjoxNSswMDowMJPflswAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTUr MDA6MDDigi5wAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAw gs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    